(() => {
  if (customElements.get('kenani-designer')) return;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });
  const MOBILE = window.matchMedia('(max-width: 749px)');
  const CENTER = () => ({ s: 100, dx: 0, dy: 0 });

  class KenaniDesigner extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.cfg = {
        form: d.form, pid: d.productId, title: d.productTitle, worker: (d.worker || '').replace(/\/$/, ''),
        cloud: d.cloud, preset: d.preset, required: d.required === 'true',
        maxBytes: (parseFloat(d.maxMb) || 10) * 1048576, placement: d.placement || 'front', home: d.placement || 'front', only: d.only || '', start: d.start || 'center', startSize: parseFloat(d.startSize) || 30, label: d.label || 'Design file'
      };
      this.pos = { s: 100, dx: 0, dy: 0 };
      this.src = null; this.url = null; this.dim = { w: 0, h: 0 };
      this.busy = false; this.gen = null; this.upTok = 0; this.genTok = 0;
      this.places = null; this.placeLabel = '';
      this.layouts = {}; this.layout = null; this.img = null; this.tint = null; this.imgCache = {};
      this.timer = null; this.raf = 0; this.retries = 0; this.live = false;
      this.later = false; this.step1 = /[?&]variant=/.test(location.search);

      const on = (sel, ev, fn) => { const el = this.q(sel); if (el) el.addEventListener(ev, fn); };
      on('[data-file]', 'change', (e) => this.pick(e.target.files[0]));
      const drop = this.q('[data-drop]');
      ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
      ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
      drop.addEventListener('drop', (e) => this.pick(e.dataTransfer.files[0]));
      on('[data-remove]', 'click', () => this.clear());
      on('[data-later]', 'click', () => this.setLater(true));
      on('[data-later-undo]', 'click', () => { this.setLater(false); this.q('[data-file]').click(); });
      this.querySelectorAll('[data-preset]').forEach((b) => b.addEventListener('click', () => this.preset(b.dataset.preset)));
      on('[data-next]', 'click', () => {
        const pick = () => document.querySelector('main [name="add"], main button[type="submit"][ref="addToCartButton"], main product-form-component button[type="submit"]') ||
          [...document.querySelectorAll('main button')].find((b) => /add to cart/i.test(b.textContent) && b.offsetParent);
        const btn = pick();
        if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      on('[data-reset]', 'click', () => { this.pos = this.home(); this.sync(); this.moved(); });
      on('[data-size]', 'input', (e) => { this.pos.s = +e.target.value; this.setProps(); this.moved(); });
      on('[data-posx]', 'input', (e) => { this.pos.dx = +e.target.value; this.setProps(); this.moved(); });
      on('[data-posy]', 'input', (e) => { this.pos.dy = +e.target.value; this.setProps(); this.moved(); });
      on('[data-update]', 'click', () => this.photos(true));

      // Blocks add to cart (and anything else submitting the product form) until a design choice is made.
      this.guard = (e) => {
        if (!this.cfg.required && !this.busy) return;
        const form = document.getElementById(this.cfg.form);
        if (!form) return;
        const t = e.target;
        let inForm = false;
        if (e.type === 'submit') inForm = t === form;
        else if (t.closest) {
          const btn = t.closest('button, [type=submit], add-to-cart-component');
          inForm = !!btn && (btn.form === form || form.contains(btn));
        }
        if (!inForm) return;
        if (this.busy) { e.preventDefault(); e.stopImmediatePropagation(); this.err('Your design is still uploading. One moment.'); return; }
        if (this.cfg.required && !this.ready()) {
          e.preventDefault(); e.stopImmediatePropagation();
          this.err('Please upload your design first, or choose to email it after ordering.');
          this.classList.remove('is-shake'); void this.offsetWidth; this.classList.add('is-shake');
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };
      document.addEventListener('click', this.guard, true);
      document.addEventListener('submit', this.guard, true);

      // A colour or size change completes step 1, reloads the product picture (colour) and refreshes the photos later.
      this.onChange = (e) => {
        if (!e.target.closest) return;
        if (e.target.closest('variant-picker')) { this.step1 = true; this.refresh(); }
        if (!this.src || !e.target.closest('variant-picker, [data-variant-picker], form')) return;
        setTimeout(async () => {
          if (this.variantId() === this._lastVariant) return;
          this._lastVariant = this.variantId();
          await this.loadLayout(); this.draw(); this.moved(true);
        }, 400);
      };
      document.addEventListener('change', this.onChange);

      this.initFloat();
      this.refresh();
    }

    q(s) { return this.querySelector(s); }
    // Starting position of the design. Presets only apply to the main print area.
    home() {
      const c = this.cfg;
      if (c.placement !== c.home || c.start === 'center') return CENTER();
      const at = { left_chest: [0.74, 0.14], right_chest: [0.26, 0.14], upper_center: [0.5, 0.14] }[c.start] || [0.5, 0.5];
      return { s: Math.round(c.startSize), dx: Math.round((at[0] - 0.5) * 100), dy: Math.round((at[1] - 0.5) * 100) };
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.guard, true);
      document.removeEventListener('submit', this.guard, true);
      document.removeEventListener('change', this.onChange);
      clearTimeout(this.timer);
      if (this._io) this._io.disconnect();
      if (this._mo) this._mo.disconnect();
      if (this._mq) MOBILE.removeEventListener('change', this._mq);
      if (this._float) this._float.remove();
    }
    err(m) { const e = this.q('[data-error]'); e.textContent = m || ''; e.hidden = !m; }
    status(m, c) { const s = this.q('[data-status]'); s.textContent = m; s.className = 'kd__status ' + (c || ''); }
    hint(m) { const h = this.q('[data-hint]'); h.textContent = m || ''; h.hidden = !m; }
    variantId() { const f = document.getElementById(this.cfg.form); const i = f && f.querySelector('[name=id]'); return i ? i.value : ''; }

    /* ---------- 1-2-3 stepper and express checkout lock ---------- */
    ready() { return !!this.url || this.later; }
    refresh() {
      const ok = this.ready();
      if (ok) this.step1 = true;
      this.toggleAttribute('data-design-ready', ok);
      // Fallback for browsers without :has(): hides express checkout until step 2 is done.
      const form = document.getElementById(this.cfg.form);
      const pfc = form && form.closest('product-form-component');
      if (pfc) pfc.classList.toggle('kd-locked', this.cfg.required && !ok);
      const scope = this.closest('.shopify-section') || document;
      scope.querySelectorAll('[data-kd-step]').forEach((el) => {
        const n = el.dataset.kdStep;
        const done = n === '1' ? this.step1 : n === '2' ? ok : false;
        el.classList.toggle('is-done', done);
        el.classList.toggle('is-active', n === '3' && ok);
        const sr = el.querySelector('[data-kd-step-state]');
        if (sr) sr.textContent = done ? ' (done)' : '';
      });
    }
    setLater(on) {
      if (on && (this.src || this.url || this.busy)) this.clear();
      this.later = on;
      this.q('[data-drop]').hidden = on;
      const btn = this.q('[data-later]');
      btn.hidden = on; btn.setAttribute('aria-pressed', String(on));
      this.q('[data-later-note]').hidden = !on;
      this.err('');
      this.setProps(); this.refresh();
    }

    /* ---------- placement presets ---------- */
    chestPos() {
      // Wearer's left chest = viewer's right, same maths as the left_chest start option in home().
      const s = Math.round(this.cfg.startSize);
      return { s, dx: 24, dy: -36 };
    }
    async preset(name) {
      const ids = (this.places || []).map((p) => p.id);
      const front = ids.includes('front') ? 'front' : this.cfg.home;
      const target = name === 'back' && ids.includes('back') ? 'back' : front;
      if (target !== this.cfg.placement) await this.choosePlace(target);
      this.pos = name === 'chest' ? this.chestPos() : CENTER();
      this.sync(); this.moved();
    }
    markPreset() {
      const p = this.pos, back = this.cfg.placement === 'back';
      const same = (a, b) => a.s === b.s && a.dx === b.dx && a.dy === b.dy;
      let cur = '';
      if (same(p, CENTER())) cur = back ? 'back' : 'full';
      else if (!back && same(p, this.chestPos())) cur = 'chest';
      this.querySelectorAll('[data-preset]').forEach((b) => {
        const onP = b.dataset.preset === cur;
        b.classList.toggle('is-on', onP); b.setAttribute('aria-pressed', String(onP));
      });
    }

    /* ---------- preview stage over the gallery ---------- */
    stage() {
      if (this._stage) return this._stage;
      const g = document.querySelector('media-gallery');
      if (!g) return null;
      const st = document.createElement('div');
      st.className = 'kd-stage'; st.hidden = true;
      st.innerHTML = '<div class="kd-stage__bar"><button type="button" class="is-on" data-v="design">Your design</button><button type="button" data-v="photos">Product photos</button></div>' +
        '<div class="kd-stage__main"><canvas data-live aria-label="Live preview of your design"></canvas><img alt="Realistic preview of your design" data-main hidden>' +
        '<div class="kd-stage__wait" data-wait><div class="kd-stage__card"><img alt="" data-wait-img><span class="kd-spin"></span><p data-wait-text>Loading your preview…</p></div></div></div>' +
        '<p class="kd-stage__note" data-note hidden><span class="kd-spin kd-spin--s"></span><span data-note-text></span></p>' +
        '<div class="kd-stage__thumbs" data-thumbs></div>';
      const parent = g.parentElement;
      parent.insertBefore(st, g);
      st.querySelectorAll('[data-v]').forEach((b) => b.addEventListener('click', () => this.view(b.dataset.v)));
      this._stage = st; this._gallery = g;
      // The theme replaces <media-gallery> on variant change; keep the current view applied to the new one.
      this._mo = new MutationObserver(() => {
        const ng = parent.querySelector(':scope > media-gallery');
        if (ng && ng !== this._gallery) { this._gallery = ng; if (this._view) this.view(this._view); }
      });
      this._mo.observe(parent, { childList: true });
      if (this._io) this._io.observe(st);
      return st;
    }
    view(v) {
      const st = this.stage(); if (!st) return;
      this._view = v;
      st.hidden = v !== 'design';
      if (this._gallery) this._gallery.classList.toggle('kd-hide', v === 'design');
      st.querySelectorAll('[data-v]').forEach((b) => b.classList.toggle('is-on', b.dataset.v === v));
      this.floatUpdate();
    }
    wait(on, text) {
      const st = this.stage(); if (!st) return;
      st.querySelector('[data-wait]').hidden = !on;
      if (text) st.querySelector('[data-wait-text]').textContent = text;
      st.querySelector('[data-wait-img]').src = this.src || '';
    }
    note(text) {
      const st = this.stage(); if (!st) return;
      const n = st.querySelector('[data-note]');
      n.hidden = !text;
      if (text) st.querySelector('[data-note-text]').textContent = text;
    }
    mode(m) {
      const st = this.stage(); if (!st) return;
      st.querySelector('[data-live]').hidden = m !== 'live';
      st.querySelector('[data-main]').hidden = m === 'live';
      st.querySelectorAll('.kd-thumb').forEach((x) => x.classList.toggle('is-on', x.dataset.m === m));
    }

    /* ---------- mobile floating thumbnail that mirrors the live canvas ---------- */
    initFloat() {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'kd-float'; b.hidden = true;
      b.setAttribute('aria-label', 'Show the full preview of your design');
      b.innerHTML = '<canvas width="240" height="240" aria-hidden="true"></canvas><span class="kd-float__tag">Preview</span>';
      b.addEventListener('click', () => { if (this._stage) this._stage.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      document.body.appendChild(b);
      this._float = b; this._fc = b.querySelector('canvas');
      this._panelIn = false; this._stageIn = false;
      const panel = this.q('[data-panel]');
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.target === panel) this._panelIn = e.isIntersecting;
          else this._stageIn = e.isIntersecting && e.intersectionRatio >= 0.35;
        });
        this.floatUpdate();
      }, { threshold: [0, 0.35] });
      this._io.observe(panel);
      this._mq = () => this.floatUpdate();
      MOBILE.addEventListener('change', this._mq);
    }
    floatUpdate() {
      if (!this._float) return;
      const st = this._stage;
      const show = MOBILE.matches && this._panelIn && !this._stageIn && !!st && !st.hidden &&
        this.live && !!this.layout && !!this.img && !this.q('[data-panel]').hidden;
      this._float.hidden = !show;
      if (show) this.mirror();
    }
    mirror() {
      if (!this._float || this._float.hidden || !this._stage) return;
      const src = this._stage.querySelector('[data-live]');
      if (!src || !src.width || !src.height) return;
      const c = this._fc, x = c.getContext('2d');
      const k = Math.min(c.width / src.width, c.height / src.height);
      const w = src.width * k, h = src.height * k;
      x.clearRect(0, 0, c.width, c.height);
      x.drawImage(src, (c.width - w) / 2, (c.height - h) / 2, w, h);
    }

    /* ---------- instant preview drawn in the browser ---------- */
    async loadLayout() {
      if (!this.cfg.worker) { this.layout = null; return; }
      const variant = this.variantId();
      const key = this.cfg.placement + '|' + variant;
      if (this.layouts[key] === undefined) {
        try {
          const qs = new URLSearchParams({ product: this.cfg.pid, title: this.cfg.title || '', variant, placement: this.cfg.placement });
          const r = await fetch(this.cfg.worker + '/layout?' + qs);
          const j = await r.json();
          this.layouts[key] = r.ok && j.image && j.area ? j : null;
        } catch (e) { this.layouts[key] = null; }
      }
      this.layout = this.layouts[key];
      this.tint = null;
      if (this.layout) {
        try {
          const L = this.layout;
          L._g = L._g || await this.getImg(L.image);
          if (L.background && !L._b) L._b = await this.getImg(L.background).catch(() => null);
        } catch (e) { this.layout = null; }
      }
    }
    getImg(src) { return this.imgCache[src] || (this.imgCache[src] = loadImg(src)); }

    draw() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.paint());
    }
    paint() {
      const st = this._stage, L = this.layout;
      if (!st || !L || !this.img) return;
      const c = st.querySelector('[data-live]');
      const k = Math.min(1, 1100 / L.width);
      const W = Math.round(L.width * k), H = Math.round(L.height * k);
      if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
      const x = c.getContext('2d');
      x.clearRect(0, 0, W, H);
      x.fillStyle = L.backgroundColor || '#f3f5fb'; x.fillRect(0, 0, W, H);
      if (L._b) x.drawImage(L._b, 0, 0, W, H);
      if (!this.tint || this.tint.w !== W) {
        const g = document.createElement('canvas'); g.width = W; g.height = H;
        const gx = g.getContext('2d');
        gx.drawImage(L._g, 0, 0, W, H);
        if (L.color) {
          gx.globalCompositeOperation = 'multiply'; gx.fillStyle = L.color; gx.fillRect(0, 0, W, H);
          gx.globalCompositeOperation = 'destination-in'; gx.drawImage(L._g, 0, 0, W, H);
        }
        this.tint = { w: W, c: g };
      }
      x.drawImage(this.tint.c, 0, 0);
      // design position, same maths as the Printful request
      const a = L.area, ar = a.width / a.height, di = this.dim.w / this.dim.h || 1;
      const s = Math.min(1.3, Math.max(0.1, this.pos.s / 100));
      let w = s, h = (w * ar) / di;
      if (h > s) { h = s; w = (h * di) / ar; }
      const dx = Math.max(-0.6, Math.min(0.6, this.pos.dx / 100)), dy = Math.max(-0.6, Math.min(0.6, this.pos.dy / 100));
      const left = (1 - w) / 2 + dx, top = (1 - h) / 2 + dy;
      const ax = a.left * k, ay = a.top * k, aw = a.width * k, ah = a.height * k;
      x.save();
      x.beginPath(); x.rect(ax, ay, aw, ah); x.clip();
      x.drawImage(this.img, ax + left * aw, ay + top * ah, w * aw, h * ah);
      x.restore();
      x.save();
      x.setLineDash([8, 6]); x.lineWidth = 2; x.strokeStyle = 'rgba(227,177,58,.85)';
      x.strokeRect(ax, ay, aw, ah);
      x.restore();
      this.mirror();
    }

    /* ---------- reacting to changes ---------- */
    moved(variantOnly) {
      this.draw();
      if (!this.cfg.worker || !this.url) return;
      clearTimeout(this.timer);
      if (this.gen) { this.hint('The realistic photos show your previous placement. The live preview is up to date. Press "Refresh realistic photos" when you are happy with it.'); return; }
      this.timer = setTimeout(() => this.photos(), 4500);
    }

    show(mockups) {
      const st = this.stage(); if (!st) return;
      const main = st.querySelector('[data-main]'), th = st.querySelector('[data-thumbs]');
      th.innerHTML = '';
      const mk = (cls, m, node, fn) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'kd-thumb' + cls; b.dataset.m = m; b.appendChild(node); b.onclick = fn; th.appendChild(b); return b; };
      if (this.layout) {
        const lt = document.createElement('span'); lt.className = 'kd-thumb__live'; lt.textContent = 'Live';
        mk(' is-on', 'live', lt, () => this.mode('live'));
      }
      mockups.forEach((m) => {
        const im = document.createElement('img'); im.src = m.url; im.alt = m.title || ''; im.loading = 'lazy';
        mk('', 'photo', im, () => { main.src = m.url; this.mode('photo'); st.querySelectorAll('.kd-thumb').forEach((x) => x.classList.toggle('is-on', x.firstChild === im)); });
      });
      main.src = mockups[0].url;
      this.wait(false);
      if (!this.layout) { this.mode('photo'); th.querySelectorAll('.kd-thumb').forEach((x, i) => x.classList.toggle('is-on', i === 0)); }
      else this.mode('live');
      this.view('design');
    }

    /* ---------- file handling ---------- */
    async pick(file) {
      this.err(''); this.hint('');
      if (!file) return;
      if (!/^image\/(png|jpeg|webp)$/.test(file.type)) return this.err('Please choose a PNG, JPG or WEBP file.');
      if (file.size > this.cfg.maxBytes) return this.err('That file is too large. Please choose a smaller one.');
      if (this.later) this.setLater(false);
      if (this.src) URL.revokeObjectURL(this.src);
      this.src = URL.createObjectURL(file);
      this.url = null; this.gen = null; this.img = null; this.retries = 0;
      clearTimeout(this.timer); this.note('');
      this.q('[data-thumb]').src = this.src;
      this.q('[data-name]').textContent = file.name;
      this.q('[data-panel]').hidden = false;
      this.q('[data-later-wrap]').hidden = true;
      this.pos = this.home();
      this.sync();
      this._lastVariant = this.variantId();
      this.upload(file);
      try {
        this.img = await loadImg(this.src);
        this.dim = { w: this.img.naturalWidth, h: this.img.naturalHeight };
      } catch (e) { return this.err('We could not read that image. Please try another file.'); }
      if (this.cfg.worker) {
        this.view('design'); this.mode('live'); this.wait(true, 'Loading your preview…');
        await this.loadPlaces();
        await this.loadLayout();
        this.wait(false);
        if (this.layout) { this.live = true; this.view('design'); this.mode('live'); this.draw(); this.moved(); }
        else { this.live = false; this.view('photos'); }
      }
      this.floatUpdate();
    }

    async loadPlaces() {
      if (!this.cfg.worker || this.places) return;
      try {
        const qs = new URLSearchParams({ product: this.cfg.pid, title: this.cfg.title || '', variant: this.variantId(), only: this.cfg.only });
        const r = await fetch(this.cfg.worker + '/placements?' + qs);
        const j = await r.json();
        this.places = (r.ok && j.placements) || [];
      } catch (e) { this.places = []; }
      const box = this.q('[data-place]'), chips = this.q('[data-chips]');
      chips.innerHTML = '';
      const list = this.places;
      const backBtn = this.q('[data-preset="back"]');
      if (backBtn) backBtn.hidden = !list.some((p) => p.id === 'back');
      if (!list.length) { box.hidden = true; return; }
      if (!list.some((p) => p.id === this.cfg.placement)) this.cfg.placement = list[0].id;
      list.forEach((p) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'kd__chip'; b.textContent = p.label; b.dataset.id = p.id;
        b.setAttribute('role', 'radio');
        b.onclick = () => this.choosePlace(p.id);
        chips.appendChild(b);
      });
      // The presets already cover front and back; only show print-area chips for other areas (e.g. sleeves).
      box.hidden = list.length < 2 || list.every((p) => p.id === 'front' || p.id === 'back');
      this.markPlace();
      this.setProps();
    }
    markPlace() {
      const cur = (this.places || []).find((p) => p.id === this.cfg.placement);
      this.placeLabel = cur ? cur.label : '';
      this.querySelectorAll('.kd__chip[data-id]').forEach((c) => { const on = c.dataset.id === this.cfg.placement; c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on); });
    }
    async choosePlace(id) {
      if (id === this.cfg.placement) return;
      this.cfg.placement = id;
      this.pos = this.home();
      this.markPlace(); this.sync();
      this.gen = null; this.hint('');
      await this.loadLayout();
      if (this.layout) { this.mode('live'); this.view('design'); this.draw(); }
      this.moved();
    }

    async upload(file) {
      if (!this.cfg.cloud || !this.cfg.preset) { this.status('Not set up', 'bad'); this.err('Uploads are not set up yet.'); return; }
      const tk = ++this.upTok;
      this.busy = true; this.status('Uploading…');
      try {
        const fd = new FormData();
        fd.append('file', file); fd.append('upload_preset', this.cfg.preset);
        const r = await fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(this.cfg.cloud) + '/image/upload', { method: 'POST', body: fd });
        const j = await r.json();
        if (tk !== this.upTok) return;
        if (!r.ok || !j.secure_url) throw new Error('fail');
        this.url = j.secure_url;
        this.status('Uploaded', 'ok'); this.busy = false; this.setProps(); this.refresh();
        if (this.cfg.worker && this.layout) this.moved();
        else if (this.cfg.worker && this.live === false && this.img) this.photos(true);
      } catch (e) {
        if (tk !== this.upTok) return;
        this.url = null; this.busy = false; this.status('Failed', 'bad'); this.err('Upload failed. Please try again.');
        this.setProps(); this.refresh();
      }
    }

    /* ---------- realistic photos from Printful, in the background ---------- */
    async photos(manual) {
      if (!this.url || !this.cfg.worker) return;
      if (manual) this.retries = 0;
      const tk = ++this.genTok;
      const variant = this.variantId();
      const sig = JSON.stringify([this.pos, this.cfg.placement, variant]);
      this.err('');
      this.q('[data-update]').disabled = true;
      this.note(this.gen ? 'Refreshing your realistic photos…' : 'Creating realistic photos. You can keep adjusting meanwhile.');
      if (!this.layout) { this.wait(true, 'Creating your preview. This takes about 15 seconds…'); this.view('design'); }
      try {
        for (;;) {
          const r = await fetch(this.cfg.worker + '/mockups', {
            method: 'POST', headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ shopifyProductId: this.cfg.pid, title: this.cfg.title, shopifyVariantId: variant, imageUrl: this.url, imgW: this.dim.w, imgH: this.dim.h, scale: this.pos.s, dx: this.pos.dx, dy: this.pos.dy, placement: this.cfg.placement })
          });
          const j = await r.json();
          if (tk !== this.genTok) return;
          if (r.status === 404 && j.error === 'unmapped') { this.note(''); this.wait(false); if (!this.layout) this.view('photos'); this.hint('A live preview is not available for this product yet. Your file will still be sent with your order.'); return; }
          if (r.status === 429 && this.retries < 3) {
            this.retries++;
            for (let left = Math.min(90, Math.max(10, j.retryAfter || 60)); left > 0; left--) {
              if (tk !== this.genTok) return;
              this.note('Many people are creating previews right now. Realistic photos in about ' + left + 's…');
              await sleep(1000);
            }
            if (tk !== this.genTok) return;
            continue;
          }
          if (!r.ok || !j.taskKey) throw new Error(j.error || 'fail');
          await sleep((j.retryAfter || 10) * 1000);
          for (let i = 0; i < 25; i++) {
            if (tk !== this.genTok) return;
            const pr = await fetch(this.cfg.worker + '/mockups/' + j.taskKey);
            if (pr.status === 429) { await sleep(6000); continue; }
            const pj = await pr.json();
            if (pj.status === 'done' && pj.mockups && pj.mockups.length) {
              this.retries = 0; this.gen = { sig };
              this.note(''); this.hint('');
              this.show(pj.mockups);
              if (JSON.stringify([this.pos, this.cfg.placement, this.variantId()]) !== sig) this.moved();
              return;
            }
            if (pj.status === 'failed' || !pr.ok) throw new Error(pj.message || pj.error || 'fail');
            await sleep(4000);
          }
          throw new Error('timeout');
        }
      } catch (e) {
        if (tk !== this.genTok) return;
        this.note(''); this.wait(false);
        if (!this.layout) this.view('photos');
        const m = String((e && e.message) || '');
        const why = /busy|too many/i.test(m) ? ' Our preview service is busy, please wait a minute.' : (m && !/^(fail|timeout|Failed to fetch)$/i.test(m) ? ' (' + m.slice(0, 120) + ')' : '');
        this.hint('We could not create the realistic photos just now.' + why + ' Your live preview above is still accurate, and your file will be sent with your order. You can press the button to try again.');
      } finally { this.q('[data-update]').disabled = false; }
    }

    setProps() {
      const u = this.q('[data-prop-url]'), p = this.q('[data-prop-pos]');
      u.name = 'properties[' + this.cfg.label + ']';
      const on = !!this.url && !this.later;
      u.value = on ? this.url : ''; u.disabled = !on;
      p.value = on ? JSON.stringify({ scale: this.pos.s, dx: this.pos.dx, dy: this.pos.dy, placement: this.cfg.placement }) : ''; p.disabled = !on;
      const a = this.q('[data-prop-area]');
      if (a) { a.value = on ? (this.placeLabel || '') : ''; a.disabled = !(on && this.placeLabel); }
      const l = this.q('[data-prop-later]');
      if (l) l.disabled = !this.later;
      this.markPreset();
    }
    sync() {
      this.q('[data-size]').value = this.pos.s;
      this.q('[data-posx]').value = this.pos.dx;
      this.q('[data-posy]').value = this.pos.dy;
      this.setProps();
    }
    clear() {
      this.upTok++; this.genTok++;
      clearTimeout(this.timer);
      if (this.src) URL.revokeObjectURL(this.src);
      this.src = null; this.url = null; this.gen = null; this.busy = false; this.img = null; this.live = false;
      this.q('[data-file]').value = '';
      this.q('[data-panel]').hidden = true;
      this.q('[data-later-wrap]').hidden = false;
      this.err(''); this.hint(''); this.note(''); this.setProps(); this.refresh();
      if (this._stage) { this._stage.hidden = true; this._view = null; if (this._gallery) this._gallery.classList.remove('kd-hide'); }
      this.floatUpdate();
    }
  }
  customElements.define('kenani-designer', KenaniDesigner);
})();
